import {createSelector} from 'reselect';
import {AppState} from '../..';
import {NotificationStatus} from '../../../shared/models/profile/notification';
import {ProvidingListApplication} from '../../../shared/models/api';
import {UscType} from '../../../shared/models/profile/uscType';

export const holderProfileSelector = () =>
  createSelector(
    (state: AppState) => state.profile.holder,
    (item) => item,
  );

export const profileSettingsSelector = () =>
  createSelector(
    (state: AppState) => state.profile.settings,
    (item) => item,
  );

export const profileUscSelector = () =>
  createSelector(
    (state: AppState) => state.profile.holder?.usc ?? '',
    (item) => item,
  );

export const profileTokenSelector = () =>
  createSelector(
    (state: AppState) => state.profile.token,
    (item) => item,
  );

export const profilePinCodeSelector = () =>
  createSelector(
    (state: AppState) => state.profile.pinCode,
    (item) => item,
  );

export const profileSessionExpiredSelector = () =>
  createSelector(
    (state: AppState) => state.profile.isSessionExpired,
    (item) => item,
  );

export const profileAuthenticationStateSelector = () =>
  createSelector(
    (state: AppState) => state.profile.isAuthenticated,
    (item) => item,
  );

export const profilePhotoSelector = () =>
  createSelector(
    (state: AppState) => state.profile.photo,
    (item) => item,
  );

export const profileNotificationsSelector = () =>
  createSelector(
    (state: AppState) => state.profile.notifications,
    (item) => item,
  );

export const profileNotificationsByIdSelector = (id: number) =>
  createSelector(
    (state: AppState) => (state.profile.notification?.id === +id ? state.profile.notification : null),
    (item) => item,
  );

export const profileRequestsSelector = () =>
  createSelector(
    (state: AppState) => state.profile.requests,
    (item) => item,
  );

export const profileNotificationsByStatusSelector = (status: NotificationStatus) =>
  createSelector(
    (state: AppState) => (state.profile.notifications || []).filter((item) => item.statusId === status),
    (item) => item,
  );

export const profileApplicationsSelector = (filter: (item: ProvidingListApplication) => boolean = () => true) =>
  createSelector(
    (state: AppState) => state.profile.applications,
    (items) => (items ? items.filter(filter) : items),
  );

export const profileApplicationsDictionariesSelector = () =>
  createSelector(
    (state: AppState) => state.profile.dictionaries,
    (dictionaries) => {
      return {
        typeApplicationDictionary: dictionaries.typeApplicationDictionary,
        statusDictionary: dictionaries.statusDictionary,
      };
    },
  );

export const profileCurrentRequestSelector = () =>
  createSelector(
    (state: AppState) => state.profile.currentRequest,
    (items) => items,
  );

export const profileApplicationsItemSelector = (applicationId: number) =>
  createSelector(profileApplicationsSelector(), (applications) => applications?.find((s) => s.id === applicationId));

export const profileChangeContactsNewValueSelector = () =>
  createSelector(
    (state: AppState) => state.profile.changeContacts.newValue,
    (items) => items,
  );

export const profileChangeContactsResponseSelector = () =>
  createSelector(
    (state: AppState) => state.profile.changeContacts.sendCodeResponse,
    (items) => items,
  );

export const profileHolderUscTypeSelector = () =>
  createSelector(
    (state: AppState) => state.profile.holder?.uscType,
    (uscType) => uscType as UscType,
  );

export const profileECardInfoSelector = () =>
  createSelector(
    (state: AppState) => state.profile.eCardInfo,
    (eCardInfo) => eCardInfo,
  );

export const profileHolderCardIssuer = () =>
  createSelector(
    (state: AppState) => state.profile.holder?.cardIssuer,
    (cardIssuer) => cardIssuer,
  );

export const profileHolderVolunteerIdSelector = (state: AppState) => state.profile.holder?.volunteerId;
export const profileHolderMolodayaArcticaIdSelector = (state: AppState) => state.profile.holder?.molodayaArcticaId;
